import { ColorFilters } from '@ardoq/color-helpers';
import { connect } from '@ardoq/rxbeach';
import {
  getActiveConditionalFormattingColorForComponent,
  isConditionalFormattingForComponentsActive,
} from 'utils/modelCssManager/getCssColors';
import { getImageColorFilterValueForColor } from '@ardoq/scope-data';
import { ArdoqId } from '@ardoq/api-types';
import { activeComponentColors$ } from 'streams/filters/activeComponentColors$';

/**
 * Returns a filter property url value for the conditional formatting color for the image of a given component.
 * (as in `url(#${getImageColorFilterId(color)})`) or an empty string if no conditional formatting is applied
 * or no modelId provided.
 */
export const getImageColorFilterValueForModel = (modelId?: ArdoqId | null) =>
  isConditionalFormattingForComponentsActive() && modelId
    ? getImageColorFilterValueForColor(
        getActiveConditionalFormattingColorForComponent(modelId)
      )
    : '';

export const ConditionalFormattingImageColorFilters = connect(
  ColorFilters,
  activeComponentColors$
);
